// React
import React from "react";
import PropTypes from "prop-types";
import store from "./../../store";

// Functions
import {
  arrangeProjectsByMetric,
  combineBuiltAreaMetricsByPercentage,
  combineBuiltAreaMetricsByArea,
  organiseMetrics,
} from "./BenchmarkingMetrics.functions";
import isEmpty from "../../validation/is-empty";

// Components
import MetricsContainer from "./BenchmarkMetricsContainer";

// Bring in Redux

/// props validation | SQ(javascript:S6774)
BenchmarkingMetrics.propTypes = {
  skipHighlight: PropTypes.bool,
  thisBenchmark: PropTypes.object,
  benchmarks: PropTypes.array,
  auth: PropTypes.object,
  currencySymbol: PropTypes.string,
  settings: PropTypes.array,
  onSettingsToggle: PropTypes.func,
};
///
export default function BenchmarkingMetrics(props) {
  const { skipHighlight } = props;

  const { thisBenchmark, benchmarks } = props;
  const { currencySymbol } = props;
  const { settings } = props;
  const { onSettingsToggle } = props;
  const { user } = store.getState().auth;
  if (isEmpty(thisBenchmark.metrics)) {
    return null;
  }
  // Evaluate the metric types for this benchmark
  let metrics = arrangeProjectsByMetric(
    thisBenchmark.metrics,
    thisBenchmark,
    benchmarks
  );
  // Add the Combined Built Area Metrics
  metrics = combineBuiltAreaMetricsByArea(metrics);

  // Add the Combined Built Area Metrics
  metrics = combineBuiltAreaMetricsByPercentage(metrics);

  // Split the metrics up
  metrics = organiseMetrics(metrics);

  const designMetrics = [];
  const costMetrics = [];
  metrics.designMetrics.forEach((m, i) => {
    const key = `designMetrics_${i}`;
    designMetrics.push(
      <MetricsContainer
        skipHighlight={skipHighlight}
        currencySymbol={currencySymbol}
        key={key}
        m={m}
        user={user}
        settings={settings}
        onSettingsToggle={onSettingsToggle}
      />
    );
  });

  metrics.costMetrics.forEach((m, i) => {
    const key = `costMetrics_${i}`;
    costMetrics.push(
      <MetricsContainer
        skipHighlight={skipHighlight}
        currencySymbol={currencySymbol}
        key={key}
        m={m}
        user={user}
        settings={settings}
        onSettingsToggle={onSettingsToggle}
      />
    );
  });
  //push GIALRA data .. this the comparisioin of LRA and GIA
  costMetrics.push(
    <MetricsContainer
      skipHighlight={skipHighlight}
      currencySymbol={currencySymbol}
      m={{
        benchmarks: [].concat(thisBenchmark).concat(benchmarks),
        metric: "GIA vs LRA Comparision",
        code: "gialra",
      }}
      user={user}
      settings={settings}
      onSettingsToggle={onSettingsToggle}
      isProjectLevelChart={true}
    />
  );

  return (
    <>
      {designMetrics.length > 0 && (
        <BenchmarkMetricsAccordion
          title="Design Metrics"
          metrics={designMetrics}
        />
      )}
      {costMetrics.length > 0 && (
        <BenchmarkMetricsAccordion title="Cost Metrics" metrics={costMetrics} />
      )}
    </>
  );
}

/// props validation | SQ(javascript:S6774)
BenchmarkMetricsAccordion.propTypes = {
  title: PropTypes.string,
  metrics: PropTypes.array,
};
///
function BenchmarkMetricsAccordion(props) {
  const { title, metrics } = props;
  return (
    <div>
      <div className="benchmarking-section-row-header">{title}</div>
      <div className="metrics-graph-box">{metrics}</div>
    </div>
  );
}
